import {GetPredefs, Predefs} from "../lib/predefs"
import {IsPageWithLocale} from "../lib/urlutils";

$(document).ready(function() {
    if (IsPageWithLocale("/user/reset-password")) {
        GetPredefs();

        $('#resetPasswordButton').click(function (e) {
            e.preventDefault();

            resetPassword();
        })
    }
});

function resetPassword() {
    let params = {
        email: $('#emailInput').val(),
        language: $('#resetPasswordLanguage').val()
    }

    M.Modal.getInstance(document.getElementById('progressModal')).open();

    $.ajax(Predefs.links.backend_url + "/user/reset_password/email", {
        method: "POST",
        data: JSON.stringify(params),
        success: function () {
            M.Modal.getInstance(document.getElementById('progressModal')).close();
            M.Modal.getInstance(document.getElementById('resetPasswordSendMailModal')).open();
        },
        error: function (xhr) {
            let responseObj = JSON.parse(xhr.responseText);
            console.log(responseObj);

            M.Modal.getInstance(document.getElementById('progressModal')).close();
            $('#errorText').html(responseObj.message)
            M.Modal.getInstance(document.getElementById('errorModal')).close();
        }
    });
}

function getPredefs2() {
    $.ajax(window.location.protocol + "//" + window.location.host + '/predefs', {
        method: 'GET',
        success: function (data) {
            predefs = data;
        }
    })
}